/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {LoggerService} from './services/logger.service';
import {Store} from '@ngxs/store';
import {ThrowError} from '../../core/state/notification/notification.actions';
import * as StackTrace from 'stacktrace-js';
import { throttle } from 'lodash-es';

@Injectable()
export class DashGisErrorHandler implements ErrorHandler {

    public handleError: (any) => void;
    constructor(private injector: Injector) {
        this.handleError = throttle(this.handleErrorInternal, 100, {leading: true, trailing: false});
    }

    private handleErrorInternal(error) {
        const logger = this.injector.get(LoggerService);
        const store = this.injector.get(Store);
        const message = error.message ? error.message : error.toString();

        logger.error(error);

        // Http errors are handled on server - don't need stack trace
        if (!error.url && !error.headers) {
            StackTrace.fromError(error).then((stackFrames) => {
                const stackString = stackFrames
                    .splice(0, 20)
                    .map((sf) => sf.toString())
                    .join('\n');
                logger.error({message, stackString});
            });
        }
        store.dispatch(new ThrowError(message));
    }
}
